export default __webpack_public_path__ + "static/media/rating-stars-icon.a22667e2.svg";